export default __webpack_public_path__ + "static/policemp-3f6fbf6c5082ec5e1b1d5540608b3ec1.png";